import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

const Image = ({ image: {ext, url, alternativeText, localFile }, ...componentProps }) => {
    if (ext === '.gif') {
        if (URL.canParse(url)) {
            return (<img src={url} alt={alternativeText || 'a decorative image'} {...componentProps} />)
        }
        return (
            <img
                src={localFile.publicURL}
                alt={alternativeText || 'a decorative image'}
                {...componentProps}
            />
        )
    }
    debugger;
    return (
        <GatsbyImage
            image={localFile.childImageSharp.gatsbyImageData}
            {...componentProps.alt ? {} : {alt: alternativeText }}
            {...componentProps }
        />
    )

}

export default Image
